import * as React from 'react';
import InfoIcon from './InfoIcon';

class Answers extends React.Component {

    render() {
        return (
            <div>
                <ul className="answers-list">
                    {this.props.answers.map((info) => <li id={info.Id} key={info.AnswerId} onClick={this.handleClick} >{info.AnswerText} {info.InformationInd ? <InfoIcon questionId={info.QuestionId} id={ info.LicenseTypeId != null ? info.LicenseTypeId : this.props.id} stateCode={this.props.stateCode} sectionName={info.SectionName} /> : null}</li>)}
                </ul>
            </div>
        );
    }
}

export default Answers;



// WEBPACK FOOTER //
// ./src/components/Answers.js